module.exports = __webpack_public_path__ + "static/media/Silver-profesional-1.a1f201f9.png";